module.exports = __webpack_public_path__ + "img/合约交易.b51f0de7.jpg";